import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EoFormComponent } from '../../form/eo-form/eo-form.component';
import { EoFormConfig } from '../../form/eo-form/eo-form.config';
import { EoFormDialogConfig } from './eo-form-dialog-config.model';

@Component({
  selector: 'eo-form-dialog',
  templateUrl: './eo-form-dialog.component.html',
  styleUrls: ['./eo-form-dialog.component.scss'],
})
export class EoFormDialogComponent {
  @ViewChild('eoForm') eoForm?: EoFormComponent;

  @Input() config?: EoFormDialogConfig;

  _visible?: boolean;
  @Input() set visible(value: boolean) {
    this._visible = value;
    // this.eoForm?.form?.reset();
  }
  get visible(): boolean {
    if (this._visible !== undefined) return this._visible;
    if (this.config?.visible != undefined) return this.config.visible;

    return false;
  }
  @Output() visibleChange = new EventEmitter<boolean>();

  _formNoValidate?: boolean;
  @Input() set formNoValidate(value: boolean) {
    this._formNoValidate = value;
  }
  get formNoValidate(): boolean {
    if (this._formNoValidate !== undefined) return this._formNoValidate;
    if (this.config?.formNoValidate !== undefined)
      return this.config.formNoValidate;
    return false;
  }

  _header?: string;
  @Input() set header(value: string) {
    this._header = value;
  }
  get header(): string {
    if (this._header !== undefined) return this._header;
    if (this.config?.header !== undefined) return this.config.header;
    return '';
  }

  _formConfig?: EoFormConfig;
  @Input() set formConfig(value: EoFormConfig | undefined) {
    this._formConfig = value;
  }
  get formConfig(): EoFormConfig | undefined {
    if (this._formConfig !== undefined) return this._formConfig;
    if (this.config?.formConfig !== undefined) return this.config.formConfig;
    return undefined;
  }

  _dialogStyleClass?: string;
  @Input() set dialogStyleClass(value: string) {
    this._dialogStyleClass = value;
  }
  get dialogStyleClass(): string {
    if (this._dialogStyleClass !== undefined) return this._dialogStyleClass;
    if (this.config?.dialogStyleClass !== undefined)
      return this.config.dialogStyleClass;
    return 'w-full md:w-6 m-2 md:m-0';
  }

  _footerStyleClass?: string;
  @Input() set footerStyleClass(value: string) {
    this._footerStyleClass = value;
  }
  get footerStyleClass(): string {
    if (this._footerStyleClass !== undefined) return this._footerStyleClass;
    if (this.config?.footerStyleClass !== undefined)
      return this.config.footerStyleClass;
    return 'flex justify-content-end gap-2 mt-2';
  }

  _submitDisabled?: boolean;
  @Input() set submitDisabled(value: boolean) {
    this._submitDisabled = value;
  }
  get submitDisabled(): boolean {
    if (this._submitDisabled !== undefined) return this._submitDisabled;
    if (this.config?.submitDisabled !== undefined)
      return this.config.submitDisabled;

    if (this.submitLoading) return true;
    if (this.formNoValidate) return false;
    return !this.eoForm?.form.valid;
  }

  _submitLabel?: string;
  @Input() set submitLabel(value: string) {
    this._submitLabel = value;
  }
  get submitLabel(): string {
    if (this._submitLabel !== undefined) return this._submitLabel;
    if (this.config?.submitLabel !== undefined) return this.config.submitLabel;
    return 'Αποθήκευση';
  }

  _submitIcon?: string;
  @Input() set submitIcon(value: string) {
    this._submitIcon = value;
  }
  get submitIcon(): string {
    if (this._submitIcon !== undefined) return this._submitIcon;
    if (this.config?.submitIcon !== undefined) return this.config.submitIcon;
    return 'pi pi-save';
  }

  _submitLoading?: boolean;
  @Input() set submitLoading(value: boolean) {
    this._submitLoading = value;
  }
  get submitLoading(): boolean {
    if (this._submitLoading !== undefined) return this._submitLoading;
    if (this.config?.submitLoading !== undefined)
      return this.config.submitLoading;
    return false;
  }

  _submitVisible?: boolean;
  @Input() set submitVisible(value: boolean) {
    this._submitVisible = value;
  }
  get submitVisible(): boolean {
    if (this._submitVisible !== undefined) return this._submitVisible;
    if (this.config?.submitVisible !== undefined)
      return this.config.submitVisible;
    return true;
  }

  _cancelDisabled?: boolean;
  @Input() set cancelDisabled(value: boolean) {
    this._cancelDisabled = value;
  }
  get cancelDisabled(): boolean {
    if (this._cancelDisabled !== undefined) return this._cancelDisabled;
    if (this.config?.cancelDisabled !== undefined)
      return this.config.cancelDisabled;
    return false;
  }

  _cancelLoading?: boolean;
  @Input() set cancelLoading(value: boolean) {
    this._cancelLoading = value;
  }
  get cancelLoading(): boolean {
    if (this._cancelLoading !== undefined) return this._cancelLoading;
    if (this.config?.cancelLoading !== undefined)
      return this.config.cancelLoading;
    return false;
  }

  _cancelLabel?: string;
  @Input() set cancelLabel(value: string) {
    this._cancelLabel = value;
  }
  get cancelLabel(): string {
    if (this._cancelLabel !== undefined) return this._cancelLabel;
    if (this.config?.cancelLabel !== undefined) return this.config.cancelLabel;
    return 'Άκυρο';
  }

  _cancelVisible?: boolean;
  @Input() set cancelVisible(value: boolean) {
    this._cancelVisible = value;
  }
  get cancelVisible(): boolean {
    if (this._cancelVisible !== undefined) return this._cancelVisible;
    if (this.config?.cancelVisible !== undefined)
      return this.config.cancelVisible;
    return true;
  }

  _cancelIcon?: string;
  @Input() set cancelIcon(value: string) {
    this._cancelIcon = value;
  }
  get cancelIcon(): string | undefined {
    if (this._cancelIcon !== undefined) return this._cancelIcon;
    if (this.config?.cancelIcon !== undefined) return this.config.cancelIcon;
    return undefined;
  }

  get formValid(): boolean {
    return this.eoForm?.form.valid ?? false;
  }

  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onFormChange: EventEmitter<any> = new EventEmitter<any>();

  protected onSubmitClick(formData: any): void {
    if (!this.eoForm?.valid) return;
    this.onSubmit.emit(formData);
    this.config?.onSubmit?.(formData);
  }

  protected onCancelClick() {
    this.visibleChange.emit(false);
    this.onCancel.emit();
    this.config?.onCancel?.();
  }

  protected onFormChangeHandler(event: any): void {
    this.onFormChange.emit(event);
    this.config?.onFormChange?.(event);
  }

  public setFormValue(
    formGroupName: string,
    formControlName: string,
    value: any
  ): void {
    this.eoForm?.setValue(formGroupName, formControlName, value);
  }

  public getFormValue(formGroupName: string, formControlName: string): any {
    return this.getFormControl(formGroupName, formControlName)?.value;
  }

  public getFormControl(
    formGroupName: string,
    formControlName: string
  ): AbstractControl<any, any> | null | undefined {
    return this.eoForm?.getFormControl(formGroupName, formControlName);
  }

  public resetForm(): void {
    this.eoForm?.form.reset();
  }
}
